import { Extension } from 'tiptap'
import ClearFormatComponent from './clearFormatComponent'
// 自定义高级编辑组件
export default class ClearFormat extends Extension {
    get name() {
      return 'ClearFormat';
    }
    commands() {
      return () => (state, dispatch) => {
          // 如果没有选中内容，直接返回
          if (state.selection.empty) {
              return false;
          }
          
          // 获取选中范围
          const { from, to } = state.selection;
          
          // 创建一个事务
          let tr = state.tr;
          
          // 获取选中范围内的文本内容（不带格式）
          const text = state.doc.textBetween(from, to, ' ');
          
          // 删除选中范围内的内容
          tr.delete(from, to);
          
          // 插入纯文本（不带格式）
          tr.insertText(text, from);
          
          // 应用事务
          if (dispatch) {
              dispatch(tr);
          }
          
          return true;
      };
    }
    menuBtnView({ isActive, commands, focus, editor, state }) {
      return {
          component: ClearFormatComponent,
          componentProps: {
          },
          componentEvents: {
              click: () => {
                editor.commands.ClearFormat();
              },
          },
      };
    }
  }